'use es6';

import CustomWidget from 'DesignData/models/CustomWidget';
export default class CustomWidgetBuffer extends CustomWidget {
  constructor(props) {
    return super(props);
  }

}